/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import JSZip from "jszip";
import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { Card, CardContent, Chip, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FiTruck, FiUser } from "react-icons/fi";
import Listagem from "../../../components/listagem";
import { useAppSelector } from "../../../store/hooks";
import { confirm } from "../../../components/confirm";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario, TipoVeiculo } from "../../../services/constantes";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterEmailUsuario, obterIdTenent, obterLimiteVeiculos, usuarioTemAlgumaPermissao } from "../../../services/seguranca";
import { converterStatusVistoriaParaTexto } from "../../../services/utilitarios";
import { ApiError, Campo, Locacao, Opcao, ProvisionResult, StatusIntegracao, StatusVistoria, Vistoria } from "../../../services/tipos";
import { FaCarSide, FaCheckCircle, FaDownload, FaEdit, FaEye, FaMotorcycle, FaTimesCircle, FaTrash } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";
import { ReciboVistoria } from "../../../components/recibo-vistoria";
import ModalApresentacao from "../../../components/locasmartcheck/ModalApresentacao";
import logoLocaSmartCheck from "../../../assets/logo-locasmartcheck.png";
import ModalAtivacao from "../../../components/locasmartcheck/ModalAtivacao";
import LogAtivacao from "../../../components/locasmartcheck/LogAtivacao";
import ModalOnboarding from "../../../components/locasmartcheck/ModalOnboarding";
import VistoriaIntegrada from "./VistoriaIntegrada";
import { useFiliais } from "../../../hooks/useFiliais";

interface VistoriaListagemProps {
    idLocacaoParaCadastro?: string;
    km?: number;
}

function VistoriaListagem({ idLocacaoParaCadastro, km }: VistoriaListagemProps) {
    const { labelComFilial } = useFiliais();
    const [isMobile] = useState(window.innerWidth <= 768);
    const [locacoesOp, setLocacoesOp] = useState<Opcao[]>([]);
    const [locacoes, setLocacoes] = useState<Locacao[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [exibirFormModalEditarObs, setExibirFormModalEditarObs] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [vistorias, setVistorias] = useState<Vistoria[]>([]);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [vistoriaSelecionado, setVistoriaSelecionado] = useState<Vistoria>({} as Vistoria);
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [dataEnvio, setDataEnvio] = useState<Date>(new Date());
    const [tipoVeiculo, setTipoVeiculo] = useState<TipoVeiculo>(TipoVeiculo.tpNenhum);
    const [habilitarCampos, setHabilitarCampos] = useState<boolean>(true);
    const [entidadeInicial, setEntidadeInicial] = useState<any>({});
    const navigate = useHistory();
    const location = useLocation();

    const [triggerPDF, setTriggerPDF] = useState(0);
    const [vistoriaParaPDF, setVistoriaParaPDF] = useState<Vistoria | null>(null);

    // LocaSmartCheck integration state
    const [statusIntegracao, setStatusIntegracao] = useState<StatusIntegracao | null>(null);
    const limiteVeiculos = obterLimiteVeiculos(token);
    const [modalApresentacaoAberto, setModalApresentacaoAberto] = useState(false);
    const [modalAtivacaoAberto, setModalAtivacaoAberto] = useState(false);
    const [logAtivacaoAberto, setLogAtivacaoAberto] = useState(false);
    const [ativacaoLoading, setAtivacaoLoading] = useState(false);
    const [provisionResult, setProvisionResult] = useState<ProvisionResult | null>(null);
    const [onboardingAberto, setOnboardingAberto] = useState(false);
    const [senhaAtivacao, setSenhaAtivacao] = useState('');
    const [abaVistoria, setAbaVistoria] = useState(0);

    const fetchLocacoes = async () => {
        setCarregandoSelect(true);
        try {
            const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((locacao: any) => ({
                codigo: locacao.id,
                valor: locacao.id,
                label: labelComFilial(`${locacao.veiculo.placa} - ${locacao.locatario.nome}`, locacao.idFilial),
            }));
            setLocacoesOp(novasOpcoes);
            setLocacoes(response.data);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoSelect(false);
        }
    }

    const fetchStatusIntegracao = async () => {
        try {
            const response = await api.get('/LocaSmartCheck/Status');
            setStatusIntegracao(response.data);
        } catch (error) {
            // Silently fail - just keep the upsell card visible
        }
    };

    useEffect(() => {
        fetchStatusIntegracao();
    }, [token]);

    const handleAtivarLocaSmartCheck = async (senha: string) => {
        setSenhaAtivacao(senha);
        setModalAtivacaoAberto(false);
        setLogAtivacaoAberto(true);
        setAtivacaoLoading(true);
        setProvisionResult(null);

        try {
            const response = await api.post('/LocaSmartCheck/Ativar', { senhaAdmin: senha });
            setProvisionResult(response.data);
        } catch (error: any) {
            const errorData = error.response?.data;
            if (errorData && errorData.steps) {
                setProvisionResult(errorData);
            } else {
                setProvisionResult({
                    success: false,
                    tenantId: '',
                    errorMessage: errorData?.Mensagem || errorData?.errorMessage || 'Erro inesperado ao ativar a integracao. Tente novamente.',
                    steps: [],
                });
            }
        } finally {
            setAtivacaoLoading(false);
        }
    };

    const handleLogAtivacaoClose = () => {
        setLogAtivacaoAberto(false);
        if (provisionResult?.success) {
            setOnboardingAberto(true);
        }
    };

    const handleOnboardingClose = () => {
        setOnboardingAberto(false);
        fetchStatusIntegracao();
        window.location.reload();
    };

    const handleRetryAtivacao = () => {
        setLogAtivacaoAberto(false);
        setModalAtivacaoAberto(true);
    };

    useEffect(() => {
        const carregarDados = async () => {
            if (!locacoes || !(locacoes.length > 0)) {
                await fetchLocacoes();
                return;
            }

            const searchParams = new URLSearchParams(location.search);
            const idLocacaoParam = searchParams.get('idLocacao');
            const kmParam = searchParams.get('km');

            if (idLocacaoParam || idLocacaoParaCadastro) {
                const idLocacao = idLocacaoParaCadastro || idLocacaoParam;

                setEntidadeInicial({
                    idLocacao,
                    hodometro: kmParam ? Number(kmParam) : undefined
                });

                setModo(TipoFormulario.tpCadastro);
                setExibirFormModal(true);

                if (idLocacao) {
                    const locacao = locacoes.filter(l => l.id == idLocacao)[0];
                    const veiculo = locacao.veiculo;

                    const tipoVeiculo = veiculo.tipoVeiculo;

                    setHabilitarCampos(!!tipoVeiculo);
                    setTipoVeiculo(tipoVeiculo);
                }
            }
        };

        carregarDados();
    }, [location.search, idLocacaoParaCadastro, locacoes]);

    const colunas = [
        {
            field: 'locacao',
            headerName: 'Locação',
            flex: 2,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                const { locatario, veiculo } = params.row.locacao;

                const getVehicleIcon = () => {
                    switch (Number(veiculo.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                const veiculoLabel = `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`;

                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <FiUser size={16} />
                            <Typography variant="body2">{locatario.nome}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                            {getVehicleIcon()}
                            <Typography variant="body2">{veiculoLabel}</Typography>
                        </Box>
                    </Box>
                );
            }
        },
        {
            field: 'hodometro',
            headerName: 'Hodômetro',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'data',
            headerName: 'Data',
            flex: 1,
            valueGetter: (params: any) => new Date(params.value),
            renderCell: renderData
        },
        {
            field: 'obs',
            headerName: 'Observação',
            flex: 1.5,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.5, renderCell: (params: any) => {
                const status = params.value;
                const statusText = converterStatusVistoriaParaTexto(status);

                let backgroundColor;
                if (status === StatusVistoria.Aprovada) backgroundColor = '#4CAF50';
                else if (status === StatusVistoria.EmAnalise) backgroundColor = '#FFC107'
                else if (status == StatusVistoria.FeitoPeloLocador) backgroundColor = '#2196F3'
                else backgroundColor = '#f44336';

                return (
                    <span style={{
                        backgroundColor,
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius: '5px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>
                        {statusText}
                    </span>
                );
            }
        },
    ];

    function renderData(params: any) {
        const diasDaSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const diaSemana = diasDaSemana[date.getDay()];
        const dataFormatada = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        const horaFormatada = date.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });

        const resetHora = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

        const hoje = resetHora(new Date());
        const comparada = resetHora(date);

        let textoExtra = `(${diaSemana})`;

        const diffMs = comparada.getTime() - hoje.getTime();
        const diffDias = diffMs / (1000 * 60 * 60 * 24);

        if (diffDias === -1) textoExtra = "(Ontem)";
        else if (diffDias === 0) textoExtra = "(Hoje)";
        else if (diffDias === 1) textoExtra = "(Amanhã)";
        else textoExtra = `(${diaSemana})`;

        return (
            <Box display="flex" flexDirection="column" lineHeight={1.2} alignItems={isMobile ? "start" : "center"}>
                <span>{dataFormatada} {horaFormatada}</span>
                <span style={{ fontSize: '13px', color: '#888' }}>{textoExtra}</span>
            </Box>
        );
    }

    const camposBase: Campo[] = [
        {
            label: 'Locação',
            nome: 'idLocacao',
            required: true,
            tipo: 'select',
            largura: 12,
            coluna: 1,
            linha: 1,
            visible: true,
            opcoes: locacoesOp,
            carregando: carregandoSelect,
            apenasLeitura: true,
            onCampoDigitar: async (e) => {
                if (e) {
                    const locacao = locacoes.filter(l => l.id == e)[0];
                    const veiculo = locacao.veiculo;
                    const tipoVeiculo = veiculo.tipoVeiculo;
                    if (!tipoVeiculo) {
                        if (await confirm('Aparentemente esse veículo não tem um tipo definido. Deseja ir para tela de veículos para editar o registro e informar um tipo?')) {
                            navigate.push('/veiculo')
                        }
                        setHabilitarCampos(false);
                    } else {
                        setHabilitarCampos(true);
                    }
                    setTipoVeiculo(tipoVeiculo);

                    const placa = veiculo.placa;
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeInicial((prev: any) => ({ ...prev, idLocacao: e, hodometro: Math.round(res.data.odometroKm) }));
                                    setEntidadeParaAtualizarNoModal({ idLocacao: e, hodometro: Math.round(res.data.odometroKm) });
                                    setForcarAtualizacaoDeEntidadeNoModal(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            },
        },
        {
            label: 'Hodômetro', nome: 'hodometro', required: true, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos
        },
        { label: 'Data de Envio', nome: 'data', required: true, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Observação', nome: 'obs', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 3, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, },
    ];

    const camposMoto: Campo[] = [
        ...camposBase,
        { label: 'Foto Frontal', nome: 'fotoFrontal', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Traseira', nome: 'fotoTraseira', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Esquerda', nome: 'fotoLateralEsquerda', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Direita', nome: 'fotoLateralDireita', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro', nome: 'fotoPneuTraseiro', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro', nome: 'fotoPneuDianteiro', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Painel Ligado', nome: 'fotoPainelLigado', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
    ];

    const camposCarro: Campo[] = [
        ...camposBase,
        { label: 'Foto Lateral Esquerda', nome: 'fotoLateralEsquerda', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Direita', nome: 'fotoLateralDireita', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Frente', nome: 'fotoFrente', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Traseira', nome: 'fotoTraseira', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Motor', nome: 'fotoMotor', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Painel', nome: 'fotoPainel', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Porta Malas', nome: 'fotoPortaMalas', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Banco Dianteiro', nome: 'fotoBancoDianteiro', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Banco Traseiro', nome: 'fotoBancoTraseiro', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro Esquerdo', nome: 'fotoPneuDianteiroEsquerdo', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro Direito', nome: 'fotoPneuDianteiroDireito', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro Esquerdo', nome: 'fotoPneuTraseiroEsquerdo', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro Direito', nome: 'fotoPneuTraseiroDireito', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Hodômetro', nome: 'fotoHodometro', required: false, tipo: 'photo', largura: 12, coluna: 1, linha: 1, visible: true, },
    ];

    const camposCadastroMoto: Campo[] = [
        {
            label: 'Locação',
            nome: 'idLocacao',
            required: true,
            tipo: 'select',
            largura: 12,
            coluna: 1,
            linha: 1,
            visible: true,
            opcoes: locacoesOp,
            carregando: carregandoSelect,
            apenasLeitura: false,
            onCampoDigitar: async (e) => {
                if (e) {
                    const locacao = locacoes.filter(l => l.id == e)[0];
                    const veiculo = locacao.veiculo;
                    const tipoVeiculo = veiculo.tipoVeiculo;
                    if (!tipoVeiculo) {
                        if (await confirm('Aparentemente esse veículo não tem um tipo definido. Deseja ir para tela de veículos para editar o registro e informar um tipo?')) {
                            navigate.push('/veiculo')
                        }
                        setHabilitarCampos(false);
                    } else {
                        setHabilitarCampos(true);
                    }
                    setTipoVeiculo(tipoVeiculo);

                    const placa = veiculo.placa;
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeInicial((prev: any) => ({ ...prev, idLocacao: e, hodometro: Math.round(res.data.odometroKm) }));
                                    setEntidadeParaAtualizarNoModal({ idLocacao: e, hodometro: Math.round(res.data.odometroKm) });
                                    setForcarAtualizacaoDeEntidadeNoModal(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            },
        },
        {
            label: 'Hodômetro', nome: 'hodometro', required: true, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos
        },
        { label: 'Data', nome: 'data', required: true, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Observação', nome: 'obs', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 3, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Foto Frontal', nome: 'fotoFrontal', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Traseira', nome: 'fotoTraseira', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Esquerda', nome: 'fotoLateralEsquerda', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Direita', nome: 'fotoLateralDireita', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro', nome: 'fotoPneuTraseiro', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro', nome: 'fotoPneuDianteiro', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Painel Ligado', nome: 'fotoPainelLigado', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, },
    ];

    const camposCadastroCarro: Campo[] = [
        {
            label: 'Locação',
            nome: 'idLocacao',
            required: true,
            tipo: 'select',
            largura: 12,
            coluna: 1,
            linha: 1,
            visible: true,
            opcoes: locacoesOp,
            carregando: carregandoSelect,
            apenasLeitura: false,
            onCampoDigitar: async (e) => {
                if (e) {
                    const locacao = locacoes.filter(l => l.id == e)[0];
                    const veiculo = locacao.veiculo;
                    const tipoVeiculo = veiculo.tipoVeiculo;
                    if (!tipoVeiculo) {
                        if (await confirm('Aparentemente esse veículo não tem um tipo definido. Deseja ir para tela de veículos para editar o registro e informar um tipo?')) {
                            navigate.push('/veiculo')
                        }
                        setHabilitarCampos(false);
                    } else {
                        setHabilitarCampos(true);
                    }
                    setTipoVeiculo(tipoVeiculo);

                    const placa = veiculo.placa;
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeInicial((prev: any) => ({ ...prev, idLocacao: e, hodometro: Math.round(res.data.odometroKm) }));
                                    setEntidadeParaAtualizarNoModal({ idLocacao: e, hodometro: Math.round(res.data.odometroKm) });
                                    setForcarAtualizacaoDeEntidadeNoModal(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            },
        },
        {
            label: 'Hodômetro', nome: 'hodometro', required: true, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos
        },
        { label: 'Data', nome: 'data', required: true, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 2, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Observação', nome: 'obs', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 3, visible: true, apenasLeitura: !habilitarCampos },
        { label: 'Foto Lateral Esquerda', nome: 'fotoLateralEsquerda', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Lateral Direita', nome: 'fotoLateralDireita', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Frente', nome: 'fotoFrente', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Traseira', nome: 'fotoTraseira', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Motor', nome: 'fotoMotor', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Painel', nome: 'fotoPainel', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Porta Malas', nome: 'fotoPortaMalas', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Banco Dianteiro', nome: 'fotoBancoDianteiro', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Banco Traseiro', nome: 'fotoBancoTraseiro', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro Esquerdo', nome: 'fotoPneuDianteiroEsquerdo', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Dianteiro Direito', nome: 'fotoPneuDianteiroDireito', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro Esquerdo', nome: 'fotoPneuTraseiroEsquerdo', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Pneu Traseiro Direito', nome: 'fotoPneuTraseiroDireito', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Foto Hodômetro', nome: 'fotoHodometro', required: false, tipo: 'image', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, },
    ];

    const pagesMoto = [
        {
            titulo: "Informações",
            campos: ["idLocacao", "hodometro", "data", "obs"]
        },
        {
            titulo: "Vista Geral",
            campos: ["fotoFrontal", "fotoTraseira", "fotoLateralEsquerda", "fotoLateralDireita"]
        },
        {
            titulo: "Pneus",
            campos: ["fotoPneuDianteiro", "fotoPneuTraseiro"]
        },
        {
            titulo: "Painel e Documentação",
            campos: ["fotoPainelLigado", "fotoHodometro"]
        },
    ];

    const pagesCarro = [
        {
            titulo: "Informações",
            campos: ["idLocacao", "hodometro", "data", "obs"]
        },
        {
            titulo: "Exterior",
            campos: ["fotoFrente", "fotoTraseira", "fotoLateralEsquerda", "fotoLateralDireita"]
        },
        {
            titulo: "Pneus",
            campos: ["fotoPneuDianteiroEsquerdo", "fotoPneuDianteiroDireito", "fotoPneuTraseiroEsquerdo", "fotoPneuTraseiroDireito"]
        },
        {
            titulo: "Interior",
            campos: ["fotoMotor", "fotoPainel", "fotoPortaMalas", "fotoBancoDianteiro", "fotoBancoTraseiro", "fotoHodometro"]
        },
    ];

    const pagesPadrao = [
        {
            titulo: "Início da Vistoria",
            campos: ["idLocacao", "hodometro", "data", "obs"]
        },
    ];

    useEffect(() => {
        fetchLocacoes();
    }, [exibirFormModal])

    const temPermissao = usuarioTemAlgumaPermissao(token, ['vistoria_visualizar']);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    const tratarErro = (error: any) => {
        setCarregando(false);
        setIsSubmiting(false);
        toast.error(`Não foi possível continuar a operação Vistoria: ${montarMensagemDeErro(error)}`);
    }

    const montarMensagemDeErro = (error: any) => {
        const msg = error.response?.data?.Mensagem;
        const data = error.response?.data;
        const response = error.response;
        return `Erro ao processar a solicitação: ${msg || 'Erro desconhecido'}. Detalhes: ${JSON.stringify(data)}. Response: ${JSON.stringify(response)}`;
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        setEntidadeInicial({});
        window.location.href = '/vistoria';
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleFecharModalEditarObs = () => {
        setExibirFormModalEditarObs(false);
        setEntidadeInicial({});
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleExclusao = (vistoria: any) => {
        if (usuarioTemAlgumaPermissao(token, ['vistoria_excluir'])) {
            setCarregando(true);
            const endpoint = vistoria.locacao.veiculo.tipoVeiculo === TipoVeiculo.tpMoto ? `/Vistoria/Moto/${vistoria.id}` : `/Vistoria/Carro/${vistoria.id}`;
            api.delete(endpoint)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Vistoria foi excluída com sucesso');
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    };

    const handleVisualizacao = async (vistoria: any) => {
        if (usuarioTemAlgumaPermissao(token, ['vistoria_visualizar'])) {
            setVistoriaSelecionado(vistoria);
            setTipoVeiculo(vistoria.locacao.veiculo.tipoVeiculo);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
        }
    };

    useEffect(() => {
        if (vistoriaSelecionado) {
            setDataEnvio(new Date(vistoriaSelecionado.data));
        }
    }, [vistoriaSelecionado])

    const obterVistorias = async () => {
        setCarregando(true);
        try {
            // Buscar vistorias de moto
            const responseMoto = await api.get(`/Vistoria/Moto/PorEmpresa/${obterIdTenent(token)}`);
            const vistoriasMoto = responseMoto.data.map((vistoria: any) => ({
                ...vistoria,
                tipoVeiculo: TipoVeiculo.tpMoto
            }));

            // Buscar vistorias de carro
            const responseCarro = await api.get(`/Vistoria/Carro/PorEmpresa/${obterIdTenent(token)}`);
            const vistoriasCarro = responseCarro.data.map((vistoria: any) => ({
                ...vistoria,
                tipoVeiculo: TipoVeiculo.tpCarro
            }));

            // Combinar e ordenar por data
            const todasVistorias = [...vistoriasMoto, ...vistoriasCarro].sort((a, b) =>
                new Date(b.data).getTime() - new Date(a.data).getTime()
            );

            setVistorias(todasVistorias);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregando(false);
            setRealizarConsulta(false);
        }
    };

    useEffect(() => {
        if (temPermissao && realizarConsulta) {
            obterVistorias();
        }
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (aprovada: boolean) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        setEntidadeInicial({});
        setFezAlgumaAcao(true);
        setCarregando(false)
        setIsSubmiting(false)
        if (aprovada) {
            toast.success('Vistoria salva com sucesso. O locatário agora poderá transmitir outra troca', { autoClose: 8000 });
            toast.info('Atenção: Armazenamos apenas as 3 últimas vistorias. As anteriores são removidas automaticamente. Para salvar algum arquivo, clique no ícone de download.', { autoClose: 12000 });
        } else {
            toast.success('Vistoria recusada com sucesso. O locatário agora poderá transmitir outra troca', { autoClose: 8000 });
            toast.info('Atenção: Armazenamos apenas as 3 últimas vistorias. As anteriores são removidas automaticamente. Para salvar algum arquivo, clique no ícone de download.', { autoClose: 12000 });
        }
    }

    const aprovarOuRecusarVistoria = async (aprovar: boolean, entidade?: any) => {
        if (entidade.status == StatusVistoria.FeitoPeloLocador) {
            toast.info('Essa troca foi criada diretamente pelo locador. Dessa forma, não tem a opção de aprovar ou recusar!');
            return;
        }
        const vistoria = entidade || vistoriaSelecionado;
        if (vistoria) {
            setIsSubmiting(true);
            try {
                const tipoVeiculo = vistoria.veiculo?.tipoVeiculo ?? vistoria.locacao?.veiculo?.tipoVeiculo;
                const endpoint = tipoVeiculo === TipoVeiculo.tpMoto
                    ? `/Vistoria/Moto/AtualizarStatus/${vistoria.id}/${aprovar ? StatusVistoria.Aprovada : StatusVistoria.Recusada}`
                    : `/Vistoria/Carro/AtualizarStatus/${vistoria.id}/${aprovar ? StatusVistoria.Aprovada : StatusVistoria.Recusada}`;

                await api.put(endpoint);
                setTimeout(() => {
                    requisicaoBemSucedida(aprovar);
                    setIsSubmiting(false);
                }, 250);
            } catch (error: any) {
                tratarErro(error);
                setIsSubmiting(false);
            }
        }

        if (await confirm("Deseja baixar os arquivos desta Vistoria?", { waitSeconds: 5 })) {
            handleDownload(vistoria);
        }
    }

    const handleSalvarEdicaoObs = async (entidade?: any) => {
        const vistoria = entidade || vistoriaSelecionado;
        if (vistoria) {
            setIsSubmiting(true);
            try {
                const endpoint = vistoria.locacao?.veiculo?.tipoVeiculo === TipoVeiculo.tpMoto
                    ? `/Vistoria/Moto/AtualizarObservacao/${vistoria.id}`
                    : `/Vistoria/Carro/AtualizarObservacao/${vistoria.id}`;

                await api.put(endpoint, JSON.stringify(entidade.obs), {
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
                setTimeout(() => {
                    setIsSubmiting(false);
                    setExibirFormModalEditarObs(false);
                    toast.success('Observação editada com sucesso!');
                    setRealizarConsulta(true);
                }, 250);
            } catch (error: any) {
                tratarErro(error);
                setIsSubmiting(false);
            }
        }
    }

    const getArquivosParaDownload = (entidade: any) => {
        if (entidade.locacao.veiculo.tipoVeiculo === TipoVeiculo.tpMoto) {
            return [
                { nome: "fotoFrontal.jpg", url: entidade.fotoFrontal },
                { nome: "fotoTraseira.jpg", url: entidade.fotoTraseira },
                { nome: "fotoLateralEsquerda.jpg", url: entidade.fotoLateralEsquerda },
                { nome: "fotoLateralDireita.jpg", url: entidade.fotoLateralDireita },
                { nome: "fotoPneuTraseiro.jpg", url: entidade.fotoPneuTraseiro },
                { nome: "fotoPneuDianteiro.jpg", url: entidade.fotoPneuDianteiro },
                { nome: "fotoPainelLigado.jpg", url: entidade.fotoPainelLigado },
                { nome: "videoDaMotoLigada.mp4", url: entidade.videoDaMotoLigada },
            ].filter(a => a.url);
        } else {
            return [
                { nome: "videoDoCarro.mp4", url: entidade.videoDoCarro },
                { nome: "fotoLateralEsquerda.jpg", url: entidade.fotoLateralEsquerda },
                { nome: "fotoLateralDireita.jpg", url: entidade.fotoLateralDireita },
                { nome: "fotoFrente.jpg", url: entidade.fotoFrente },
                { nome: "fotoTraseira.jpg", url: entidade.fotoTraseira },
                { nome: "fotoMotor.jpg", url: entidade.fotoMotor },
                { nome: "fotoPainel.jpg", url: entidade.fotoPainel },
                { nome: "fotoPortaMalas.jpg", url: entidade.fotoPortaMalas },
                { nome: "fotoBancoDianteiro.jpg", url: entidade.fotoBancoDianteiro },
                { nome: "fotoBancoTraseiro.jpg", url: entidade.fotoBancoTraseiro },
                { nome: "fotoPneuDianteiroEsquerdo.jpg", url: entidade.fotoPneuDianteiroEsquerdo },
                { nome: "fotoPneuDianteiroDireito.jpg", url: entidade.fotoPneuDianteiroDireito },
                { nome: "fotoPneuTraseiroEsquerdo.jpg", url: entidade.fotoPneuTraseiroEsquerdo },
                { nome: "fotoPneuTraseiroDireito.jpg", url: entidade.fotoPneuTraseiroDireito },
                { nome: "fotoHodometro.jpg", url: entidade.fotoHodometro },
            ].filter(a => a.url);
        }
    };

    const handleDownload = async (entidade: any) => {
        const arquivos = getArquivosParaDownload(entidade);
        if (arquivos.length === 0) {
            toast.info('Não é possível baixar pois os arquivos já foram excluídos. Lembrando que só mantemos as 3 últimas vistorias do veículo.');
            return;
        }

        setVistoriaParaPDF(entidade);
        setTriggerPDF(prev => prev + 1);
    };

    const handleRegistrarVistoria = async (entidade: any) => {
        setIsSubmiting(true);

        const formData = new FormData();
        const isMoto = tipoVeiculo === TipoVeiculo.tpMoto;
        const endpoint = isMoto ? '/Vistoria/Moto' : '/Vistoria/Carro';

        formData.append("idLocacao", entidade.idLocacao);
        formData.append("hodometro", entidade.hodometro.toString());
        formData.append("data", entidade.data);
        formData.append("obs", entidade.obs || "");
        formData.append("status", StatusVistoria.FeitoPeloLocador.toString());
        formData.append("idEmpresa", obterIdTenent(token));

        if (isMoto) {
            if (entidade.fotoFrontal) formData.append("fotoFrontal", entidade.fotoFrontal);
            if (entidade.fotoTraseira) formData.append("fotoTraseira", entidade.fotoTraseira);
            if (entidade.fotoLateralEsquerda) formData.append("fotoLateralEsquerda", entidade.fotoLateralEsquerda);
            if (entidade.fotoLateralDireita) formData.append("fotoLateralDireita", entidade.fotoLateralDireita);
            if (entidade.fotoPneuTraseiro) formData.append("fotoPneuTraseiro", entidade.fotoPneuTraseiro);
            if (entidade.fotoPneuDianteiro) formData.append("fotoPneuDianteiro", entidade.fotoPneuDianteiro);
            if (entidade.fotoPainelLigado) formData.append("fotoPainelLigado", entidade.fotoPainelLigado);
            if (entidade.videoDaMotoLigada) formData.append("videoDaMotoLigada", entidade.videoDaMotoLigada);
        } else {
            if (entidade.videoDoCarro) formData.append("videoDoCarro", entidade.videoDoCarro);
            if (entidade.fotoLateralEsquerda) formData.append("fotoLateralEsquerda", entidade.fotoLateralEsquerda);
            if (entidade.fotoLateralDireita) formData.append("fotoLateralDireita", entidade.fotoLateralDireita);
            if (entidade.fotoFrente) formData.append("fotoFrente", entidade.fotoFrente);
            if (entidade.fotoTraseira) formData.append("fotoTraseira", entidade.fotoTraseira);
            if (entidade.fotoMotor) formData.append("fotoMotor", entidade.fotoMotor);
            if (entidade.fotoPainel) formData.append("fotoPainel", entidade.fotoPainel);
            if (entidade.fotoPortaMalas) formData.append("fotoPortaMalas", entidade.fotoPortaMalas);
            if (entidade.fotoBancoDianteiro) formData.append("fotoBancoDianteiro", entidade.fotoBancoDianteiro);
            if (entidade.fotoBancoTraseiro) formData.append("fotoBancoTraseiro", entidade.fotoBancoTraseiro);
            if (entidade.fotoPneuDianteiroEsquerdo) formData.append("fotoPneuDianteiroEsquerdo", entidade.fotoPneuDianteiroEsquerdo);
            if (entidade.fotoPneuDianteiroDireito) formData.append("fotoPneuDianteiroDireito", entidade.fotoPneuDianteiroDireito);
            if (entidade.fotoPneuTraseiroEsquerdo) formData.append("fotoPneuTraseiroEsquerdo", entidade.fotoPneuTraseiroEsquerdo);
            if (entidade.fotoPneuTraseiroDireito) formData.append("fotoPneuTraseiroDireito", entidade.fotoPneuTraseiroDireito);
            if (entidade.fotoHodometro) formData.append("fotoHodometro", entidade.fotoHodometro);
        }

        try {
            await api.post(endpoint, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                timeout: 60000
            });

            toast.success('Vistoria registrada com sucesso');
            setExibirFormModal(false);
            setEntidadeInicial({});
            setRealizarConsulta(true);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSubmiting(false);
            setCarregando(false);
        }
    };

    const handleEditarVistoria = async (entidade: any) => {
        setIsSubmiting(true);

        const formData = new FormData();
        const isMoto = tipoVeiculo === TipoVeiculo.tpMoto;
        const endpoint = isMoto ? '/Vistoria/Moto' : '/Vistoria/Carro';

        const camposBasicos = [
            'id', 'idLocacao', 'hodometro', 'data', 'obs',
            'status', 'idEmpresa'
        ];

        camposBasicos.forEach(key => {
            if (entidade[key] !== null && entidade[key] !== undefined) {
                if (['id', 'idLocacao', 'hodometro', 'status', 'idEmpresa'].includes(key)) {
                    formData.append(key, entidade[key].toString());
                } else {
                    formData.append(key, entidade[key]);
                }
            }
        });

        formData.append("status", StatusVistoria.FeitoPeloLocador.toString());
        formData.append("idEmpresa", obterIdTenent(token));

        if (isMoto) {
            const camposMoto = [
                'fotoFrontal', 'fotoTraseira', 'fotoLateralEsquerda',
                'fotoLateralDireita', 'fotoPneuTraseiro', 'fotoPneuDianteiro',
                'fotoPainelLigado', 'videoDaMotoLigada'
            ];

            camposMoto.forEach(campo => {
                if (entidade[campo] && typeof entidade[campo] !== 'string') {
                    formData.append(campo, entidade[campo]);
                }
            });
        } else {
            const camposCarro = [
                'videoDoCarro', 'fotoLateralEsquerda', 'fotoLateralDireita',
                'fotoFrente', 'fotoTraseira', 'fotoMotor', 'fotoPainel',
                'fotoPortaMalas', 'fotoBancoDianteiro', 'fotoBancoTraseiro',
                'fotoPneuDianteiroEsquerdo', 'fotoPneuDianteiroDireito',
                'fotoPneuTraseiroEsquerdo', 'fotoPneuTraseiroDireito', 'fotoHodometro'
            ];

            camposCarro.forEach(campo => {
                if (entidade[campo] && typeof entidade[campo] !== 'string') {
                    formData.append(campo, entidade[campo]);
                }
            });
        }

        try {
            await api.put(endpoint, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            setTimeout(() => {
                toast.success('Vistoria atualizada com sucesso');
                setRealizarConsulta(true);
                setExibirFormModal(false);
                setEntidadeInicial({});
                setFezAlgumaAcao(true);
                setCarregando(false);
                setIsSubmiting(false);
            }, 250);
        } catch (error: any) {
            tratarErro(error);
            setIsSubmiting(false);
        }
    };

    const getCamposParaModal = () => {
        if (vistoriaSelecionado?.status === StatusVistoria.FeitoPeloLocador) {
            return tipoVeiculo === TipoVeiculo.tpMoto ? camposCadastroMoto : camposCadastroCarro;
        }

        if (modo === TipoFormulario.tpCadastro) {
            return tipoVeiculo === TipoVeiculo.tpMoto ? camposCadastroMoto : camposCadastroCarro;
        }

        return tipoVeiculo === TipoVeiculo.tpMoto ? camposMoto : camposCarro;
    };

    const getPagesParaModal = () => {
        if (tipoVeiculo === TipoVeiculo.tpMoto) {
            return pagesMoto;
        } else if (tipoVeiculo === TipoVeiculo.tpCarro) {
            return pagesCarro;
        } else {
            return pagesPadrao;
        }
    };

    return (
        <>
            <LocaSmartLayout>
                {/* Banner LocaSmartCheck - Em breve (escondido para ativação direta) */}
                {!statusIntegracao?.integrado && (
                    <Card
                        onClick={() => setModalApresentacaoAberto(true)}
                        sx={{
                            mb: 3,
                            background: 'linear-gradient(135deg, #0a1929 0%, #132f4c 40%, #1a3a5c 100%)',
                            color: 'white',
                            cursor: 'pointer',
                            borderRadius: 3,
                            overflow: 'hidden',
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 20px rgba(10, 25, 41, 0.3)',
                            '&:hover': {
                                transform: 'translateY(-3px)',
                                boxShadow: '0 12px 35px rgba(10, 25, 41, 0.5)',
                            },
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '40%',
                                height: '100%',
                                background: 'radial-gradient(circle at 70% 50%, rgba(255,255,255,0.08) 0%, transparent 60%)',
                                pointerEvents: 'none',
                            },
                        }}
                    >
                        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 3, px: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                <Box
                                    component="img"
                                    src={logoLocaSmartCheck}
                                    alt="LocaSmartCheck"
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: '50%',
                                        flexShrink: 0,
                                        objectFit: 'cover',
                                    }}
                                />
                                <Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3 }}>
                                        <Box sx={{ backgroundColor: '#4caf50', borderRadius: 1, px: 0.8, py: 0.1 }}>
                                            <Typography sx={{ fontSize: 9, fontWeight: 800, color: '#fff', letterSpacing: 1 }}>
                                                NOVO
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Typography variant="h6" fontWeight="800" sx={{ lineHeight: 1.2, mb: 0.5, color: '#fff' }}>
                                        LocaSmartCheck — Vistorias Profissionais
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                        App exclusivo de vistorias com checklist personalizado, assinatura digital, fotos e relatórios em PDF. A partir de R$ 19,90/mês
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                borderRadius: 2,
                                px: 2.5,
                                py: 1,
                                textAlign: 'center',
                                flexShrink: 0,
                                ml: 2,
                                border: '1px solid rgba(255,255,255,0.3)',
                                display: { xs: 'none', sm: 'block' },
                            }}>
                                <Typography variant="body2" fontWeight="700" sx={{ whiteSpace: 'nowrap', color: '#fff' }}>
                                    Quero conhecer
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                )}

                {/* Modais de ativação — escondidos do banner, usados apenas via admin */}
                <ModalApresentacao
                    open={modalApresentacaoAberto}
                    onClose={() => setModalApresentacaoAberto(false)}
                    onInteresse={() => {
                        setModalApresentacaoAberto(false);
                        setModalAtivacaoAberto(true);
                    }}
                />

                <ModalAtivacao
                    open={modalAtivacaoAberto}
                    onClose={() => setModalAtivacaoAberto(false)}
                    onAtivar={handleAtivarLocaSmartCheck}
                    limitePlacas={limiteVeiculos}
                />

                <LogAtivacao
                    open={logAtivacaoAberto}
                    loading={ativacaoLoading}
                    provisionResult={provisionResult}
                    onClose={handleLogAtivacaoClose}
                    onRetry={handleRetryAtivacao}
                />

                <ModalOnboarding
                    open={onboardingAberto}
                    onClose={handleOnboardingClose}
                    email={obterEmailUsuario(token)}
                    senha={senhaAtivacao}
                />

                {statusIntegracao?.integrado === true && (
                    <>
                    {vistorias.length > 0 ? (
                    <Tabs
                        value={abaVistoria}
                        onChange={(_, v) => setAbaVistoria(v)}
                        sx={{ mb: 1, minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0.5, textTransform: 'none', fontWeight: 600 } }}
                    >
                        <Tab label="LocaSmartCheck" />
                        <Tab label={`Anteriores (${vistorias.length})`} />
                    </Tabs>
                    ) : null}

                    {abaVistoria === 0 && (
                        <VistoriaIntegrada onAbrirOnboarding={() => setOnboardingAberto(true)} />
                    )}

                    {abaVistoria === 1 && vistorias.length > 0 && (
                    <>
                    <Listagem
                        permissoes={{ novo: ['vistoria_novo'], editar: ['vistoria_editar'], excluir: ['vistoria_excluir'] }}
                        colunas={colunas}
                        linhas={vistorias}
                        nomeEntidade="Vistoria (Legado)"
                        nomePropriedade="obs"
                        carregando={carregando}
                        IconeEntidade={FaCheckCircle}
                        exibirAcoesDeCrud={false}
                        ocultarNovo={true}
                        acoesExtras={[{
                            Icone: FaEye, OnClick(entidade) {
                                handleVisualizacao(entidade);
                            },
                            Texto: "Visualizar", Tamanho: "medium",
                        }, {
                            Icone: FaEdit, OnClick(entidade) {
                                setVistoriaSelecionado(entidade);
                                setTipoVeiculo(entidade.locacao.veiculo.tipoVeiculo);
                                setModo(TipoFormulario.tpEdicao);
                                setExibirFormModal(true);
                            },
                            Texto: "Analisar", Tamanho: "medium",
                            Condicao: (entidade: any) => entidade.status != StatusVistoria.Aprovada && entidade.status != StatusVistoria.Recusada,
                            TooltipDisabled: "Vistoria já analisada",
                        }, {
                            Icone: FaDownload, OnClick(entidade) { handleDownload(entidade); },
                            Texto: "Baixa arquivos", Tamanho: "medium",
                        }, {
                            Icone: FaCheckCircle, OnClick(entidade) { aprovarOuRecusarVistoria(true, entidade); },
                            Texto: "Aprovar Vistoria", Tamanho: "medium",
                            Condicao: (entidade: any) => entidade.status != StatusVistoria.Aprovada && entidade.status != StatusVistoria.Recusada && entidade.status != StatusVistoria.FeitoPeloLocador,
                            TooltipDisabled: "Vistoria já analisada ou criada pelo locador",
                        }, {
                            Icone: FaTimesCircle, OnClick(entidade) { aprovarOuRecusarVistoria(false, entidade); },
                            Texto: "Recusar Vistoria", Tamanho: "medium",
                            Condicao: (entidade: any) => entidade.status != StatusVistoria.Aprovada && entidade.status != StatusVistoria.Recusada && entidade.status != StatusVistoria.FeitoPeloLocador,
                            TooltipDisabled: "Vistoria já analisada ou criada pelo locador",
                        }, {
                            Icone: FaTrash, OnClick(entidade) { handleExclusao(entidade); },
                            Texto: "Excluir", Tamanho: "medium",
                        }, {
                            Icone: FaEdit, OnClick(entidade) {
                                setVistoriaSelecionado(entidade);
                                setExibirFormModalEditarObs(true);
                            },
                            Texto: "Editar Observação", Tamanho: "medium",
                        }]}
                        handleCriar={() => {}}
                        handleExclusao={handleExclusao}
                        handleVisualizacao={handleVisualizacao}
                        handleSelecionarEntidade={setVistoriaSelecionado}
                    acoesEmLote={[
                    ]}
                    />
                    </>
                    )}
                    </>
                )}

                {!statusIntegracao?.integrado && (
                <>
                <Listagem
                    permissoes={{ novo: ['vistoria_novo'], editar: ['vistoria_editar'], excluir: ['vistoria_excluir'] }}
                    colunas={colunas}
                    linhas={vistorias}
                    nomeEntidade={statusIntegracao?.integrado ? "Vistoria (Legado)" : "Vistoria"}
                    nomePropriedade="obs"
                    carregando={carregando}
                    IconeEntidade={FaCheckCircle}
                    exibirAcoesDeCrud={false}
                    ocultarNovo={!!statusIntegracao?.integrado}
                    acoesExtras={[{
                        Icone: FaEdit, OnClick(entidade) {
                            if (entidade.status == StatusVistoria.Aprovada || entidade.status == StatusVistoria.Recusada) {
                                setExibirFormModal(false);
                                toast.info('A Vistoria já foi analisada anteriormente.');
                                return;
                            }

                            setVistoriaSelecionado(entidade);
                            setTipoVeiculo(entidade.locacao.veiculo.tipoVeiculo);
                            setModo(TipoFormulario.tpEdicao);
                            setExibirFormModal(true);
                        },
                        Texto: "Analisar", Tamanho: "medium",
                    }, {
                        Icone: FaTrash, OnClick(entidade) {
                            handleExclusao(entidade);
                        },
                        Texto: "Excluir", Tamanho: "medium",
                    }, {
                        Icone: FaDownload, OnClick(entidade) {
                            handleDownload(entidade);
                        },
                        Texto: "Baixa arquivos", Tamanho: "medium",
                    }, {
                        Icone: FaCheckCircle, OnClick(entidade) {
                            aprovarOuRecusarVistoria(true, entidade);
                        },
                        Texto: "Aprovar Vistoria", Tamanho: "medium",
                    },
                    {
                        Icone: FaTimesCircle, OnClick(entidade) {
                            aprovarOuRecusarVistoria(false, entidade);
                        },
                        Texto: "Recusar Vistoria", Tamanho: "medium",
                    }, {
                        Icone: FaEdit, OnClick(entidade) {
                            setVistoriaSelecionado(entidade);
                            setExibirFormModalEditarObs(true);
                        },
                        Texto: "Editar Observação", Tamanho: "medium",
                    },]}
                    handleEditar={(entidade: any) => {
                    }}
                    handleCriar={() => {
                        setModo(TipoFormulario.tpCadastro);
                        setVistoriaSelecionado({} as Vistoria);
                        setExibirFormModal(true);
                    }}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setVistoriaSelecionado}
                    acoesEmLote={[
                    ]}
                />
                </>
                )}

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={
                        [{
                            coluna: 1, label: "Observação", largura: 12, linha: 1, nome: "obs", required: true, tipo: "memo",
                        }]
                    }
                    show={exibirFormModalEditarObs}
                    carregando={isSubmiting}
                    onHide={handleFecharModalEditarObs}
                    onCancel={handleFecharModalEditarObs}
                    entidadeSelecionada={vistoriaSelecionado}
                    apiConfig={
                        {
                            endpoint: "",
                            requisicaoBemSucedida: () => { setExibirFormModalEditarObs(false) },
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    titulo="Editar Observação"
                    onSave={async (entidade: any) => { handleSalvarEdicaoObs(entidade) }}
                />
                <ModalForm
                    planoPremium={!ehPlanoGratuito(token) || estaEmPeriodoDeTeste(token)}
                    modo={modo}
                    tamanho="xl"
                    corBotaoOk={modo == TipoFormulario.tpCadastro ? undefined : "#4CAF50"}
                    footerText={modo == TipoFormulario.tpCadastro ? [] : vistoriaSelecionado.status == StatusVistoria.FeitoPeloLocador ? [{ text: 'Essa Vistoria não foi enviada pelo locatário', color: '#1F467E' }] : [{ text: dataEnvio ? `Data de envio: ${dataEnvio.toLocaleString('pt-BR')}` : '' }]}
                    campos={getCamposParaModal()}
                    onSave={async (entidade: any) => {
                        if (!habilitarCampos) {
                            if (await confirm('Aparentemente esse veículo não tem um tipo definido. Deseja ir para tela de veículos para editar o registro e informar um tipo?')) {
                                navigate.push('/veiculo')
                            }
                            return;
                        }
                        if (modo == TipoFormulario.tpCadastro) {
                            await handleRegistrarVistoria(entidade);
                        } else {
                            if (vistoriaSelecionado && vistoriaSelecionado.status == StatusVistoria.FeitoPeloLocador) {
                                handleEditarVistoria(entidade)
                            } else {
                                await aprovarOuRecusarVistoria(true, entidade);
                            }
                        }
                    }}
                    show={exibirFormModal}
                    isSaving={isSubmiting}
                    carregando={carregando}
                    tituloBotaoOk={modo == TipoFormulario.tpCadastro ? 'Registrar' : vistoriaSelecionado && vistoriaSelecionado.status == StatusVistoria.FeitoPeloLocador ? 'Salvar' : "Aprovar"}
                    botaoExtra={(modo == TipoFormulario.tpCadastro || (vistoriaSelecionado && vistoriaSelecionado.status == StatusVistoria.FeitoPeloLocador)) ? undefined : {
                        cor: "#f44336", titulo: "Reprovar", onClick: async (entidade) => {
                            await aprovarOuRecusarVistoria(false, entidade);
                        },
                    }}
                    titulo={modo == TipoFormulario.tpCadastro ? tipoVeiculo == TipoVeiculo.tpMoto ? "Registrando Vistoria (Moto)" : "Registrando Vistoria (Carro)" : "Conferência de Vistoria"}

                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    pages={getPagesParaModal()}
                    ajudinha={
                        {
                            texto: "Aqui, você poderá acompanhar as vistorias informadas pelo seu locatário através do nosso APP. Caso queira, também é possível registrar uma Vistoria manualmente",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={modo === TipoFormulario.tpCadastro ? entidadeInicial : vistoriaSelecionado}
                    apiConfig={
                        {
                            endpoint: "Vistoria",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: modo === TipoFormulario.tpCadastro ? entidadeInicial : entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                />

                {vistoriaParaPDF && (
                    <ReciboVistoria
                        vistoria={vistoriaParaPDF}
                        trigger={triggerPDF}
                    />
                )}
            </LocaSmartLayout>
        </>
    );
}

export default VistoriaListagem;